import React, { SyntheticEvent, useCallback, useEffect, useState } from "react";

import { useHistory, useLocation } from "react-router";
import { useProperty } from "../../components/property-provider";
import { useUserPropertyTickers } from "../../components/user-tickers-providers";
import { NavMenu } from "./navMenu";

import { SVGMenu } from "./assets";

import { useConfig } from "../../lib/config";

import { useKeycloak } from "../../components/keycloak-provider";
import { useLocaleProvider } from "../../components/locale-provider";
import { FormattedMessage } from "react-intl";
import { SearchBarTailwind } from "../../components/search-bar-tailwind";
import moment from "moment";
import "moment/locale/es";

export interface PropertySelectorProps {
  isWitAdmin: boolean | undefined;
  userProfile?: string;
}

export function PropertySelector({ isWitAdmin, userProfile }: PropertySelectorProps) {
  const keycloak = useKeycloak();
  const history = useHistory();
  const config = useConfig();
  const localeProvider = useLocaleProvider();
  const property = useProperty();
  const userPropertyTickersList = useUserPropertyTickers();
  const propertyInfo = property.info;

  const [propertyTickerOptions, setPropertyTickerOptions] = useState<any>([]);

  const location = useLocation();

  const handleChange = useCallback(
    (option: string) => {
      //For now, we try to take the user to the same section on the new property
      const locPieces = location.pathname.split("/");
      history.push(`/${option}/reservations`);
    },
    [location]
  );

  const handleLogout = useCallback(
    (e: SyntheticEvent) => {
      e.preventDefault();
      keycloak.logout();
    },
    [keycloak, config]
  );

  const changeToEs = useCallback(() => {
    localeProvider.setLocale("es-ES");
    moment.locale("es");
  }, [localeProvider]);

  const changeToEn = useCallback(() => {
    localeProvider.setLocale("en-US");
    moment.locale("en");
  }, [localeProvider]);

  useEffect(() => {
    const fetchPropertyTickers = async () => {
      const newDataList = userPropertyTickersList.map(option => ({ value: option, label: option }));
      setPropertyTickerOptions(newDataList);
    };

    fetchPropertyTickers();
  }, [userPropertyTickersList]);

  const changeLanguage = useCallback(() => {
    localeProvider.currentLocale === "en-US" ? changeToEs() : changeToEn();
  }, [localeProvider, changeToEs, changeToEn]);

  return (
    <div className="flex gap-[20px] justify-end items-center">
      <div className="flex flex-col truncate border-r-[2px] border-[#2E3862] h-[50px] justify-content-center pr-[20px]">
        <span className="font-semibold text-[#2E3862] text-lg truncate">{propertyInfo.ticker}</span>
        {isWitAdmin && (
          <div className="text-xs text-end font-normal text-[#979CB1]">
            <div>{propertyInfo.partner}</div>
          </div>
        )}
      </div>

      <div className="flex justify-end items-center">
        <SearchBarTailwind data={propertyTickerOptions} handleSelectOption={handleChange} />
      </div>

      <NavMenu title={SVGMenu["HAMBURGER"]}>
        <div
          id="dropdownLeft"
          className="z-10 fixed mx-3 mt-1 right-0 bg-white divide-y divide-gray-100 rounded-lg shadow">
          <ul className="p-3 text-sm text-gray-600" aria-labelledby="dropdownLeftButton">
            <li className="flex items-center p-2 hover:bg-[#F9F9FA]">
              <span>{SVGMenu.PROFILE}</span>
              <span className="text-[#5C5C5C] ml-2">
                {userProfile && <span className="font-semibold">{userProfile}</span>}
              </span>
            </li>
            <li className="flex items-center p-2 hover:bg-[#F9F9FA]" onClick={changeLanguage}>
              <span>{SVGMenu.LANG}</span>
              <span className="text-[#5C5C5C] ml-2 hover:underline hover:text-[#2E3862]">
                <FormattedMessage
                  {...(localeProvider.currentLocale === "en-US"
                    ? {
                        id: "header.spanish",
                        defaultMessage: "Español",
                      }
                    : {
                        id: "header.english",
                        defaultMessage: "English",
                      })}
                />
              </span>
            </li>
            <li className="flex items-center p-2 hover:bg-[#F9F9FA]" onClick={handleLogout}>
              <span>{SVGMenu.LOGOUT}</span>
              <span className="text-[#5C5C5C] ml-2 hover:underline hover:text-[#2E3862]">
                <FormattedMessage {...{ id: "header.logout", defaultMessage: "exit" }} />
              </span>
            </li>
          </ul>
        </div>
      </NavMenu>
    </div>
  );
}
